export const onlyNumber = (text: string) => {
	if (!text) return '';
	return text.replace(/\D/g, '');
};
